module.exports = __webpack_public_path__ + "img/right.2820fa46.svg";